// // WorkspaceContext.tsx
// import React, { createContext, useContext } from 'react';
// import { useStore } from 'zustand';
// import { WorkspaceStore } from '../../Redux/zustand_WorkspaceStore';
// import store from '../../Redux/store';

// const WorkspaceContext = createContext<WorkspaceStore | null>(null);

// export const Zustand_WorkspaceProvider: React.FC<{
//   store: WorkspaceStore;
//   children: React.ReactNode;
// }> = ({ store, children }) => {
//   return <WorkspaceContext.Provider value={store}>{children}</WorkspaceContext.Provider>;
// };

// export const useZustandWorkspaceStore = <T,>(
//   selector: (state: ReturnType<WorkspaceStore['getState']>) => T
// ): T => {
//   const store = useContext(WorkspaceContext);
//   if (!store) throw new Error('WorkspaceProvider is missing');
//   return useStore(store, selector);
// };

// export const useWorkspaceScopedStore = (): WorkspaceStore => {
//   const store = useContext(WorkspaceContext);
//   if (!store) throw new Error('WorkspaceProvider is missing');
//   return store;
// };

import { createStore } from 'zustand';
import { createGenericSlice } from '../../Redux/ZustandGenericSlice';
import { WorkspaceApiDTO_Workspace } from '../../Interfaces/APIContracts/WorkspaceApiDTO_Workspace';
import { createZustandContext } from '../../Redux/zustandGenericFactory';
import { ApiDTO_MinimalUser } from '../../Interfaces/APIContracts/ApiDTO_MinimalUser';
import { WorkspaceApiDTO_PrivacyLock } from '../../Interfaces/APIContracts/WorkspaceApiDTO_PrivacyLock';
import { VisualUnitApiDTO_VisualUnit } from '../../Interfaces/APIContracts/VisualUnitApiDTO_VisualUnit';

export class class_WorkspaceApiDTO_Workspace implements WorkspaceApiDTO_Workspace {
  WorkspaceId = -1;
  Name = "";
  Description = "";
  NumberOfVUs = 0;
  LastUpdatedOn = "Never";
  CreatedOn = "A century ago";
  Privacy = {} as WorkspaceApiDTO_PrivacyLock;
  PrivacyInt = 0;
  VisualUnits = [] as VisualUnitApiDTO_VisualUnit[];
  wsid = "Not DEfined";
  Type = "Don't Type";
  AdditionalData = {};
  ProfilePic = "Not Defined";
  CreatedBy= {} as ApiDTO_MinimalUser;
  LastUpdatedByUser = {} as ApiDTO_MinimalUser;
  SharedRolesCount = 0;
  SharedUsersCount = 0;
  rgborname_color = "white";
  SharedUsersInfo = [];
  ShareType = -1;
  UserTypeNum = -1;
  RolesForWorkSpace = [];
  PrivacyLock = 0;
  visualUnitId = 0;
  allowEdit = false;
  AppGUID = "";
  Links = [];
  Warning = "";
  MessageResults = [];

}
// 1. Create store factory
const createWorkspaceStore = () =>
  createStore(createGenericSlice(class_WorkspaceApiDTO_Workspace, 'workspaceState', 'setupWorkspace'));

// 2. Create context + hooks using the store's shape
const {
  Provider: Zustand_WorkspaceProvider,
  useStoreSelector: useWorkspaceStore,
  useScopedStore: useZustandWorkspaceStore,
} = createZustandContext<ReturnType<ReturnType<typeof createWorkspaceStore>['getState']>>();

export {
  createWorkspaceStore,
  Zustand_WorkspaceProvider,
  useWorkspaceStore,
  useZustandWorkspaceStore,
};
